import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import PageLayout from 'layouts/PageLayout/PageLayout';
import buddyIcon from 'assets/images/buddy_128x128.png';
import classes from './GetPermission.module.scss';

const messages = defineMessages({
  lifesize: {
    id: 'companyName',
    defaultMessage: 'Lifesize'
  },
  allow: {
    id: 'allow',
    defaultMessage: 'Allow'
  }
});

class GetPermission extends React.Component {
  constructor(props) {
    super(props);
    this.state = { permissionVisible: false };
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.isAcquiringPrimaryStream &&
      !this.props.showPermissionPage
      && nextProps.showPermissionPage) {
      this.setState({ permissionVisible: true });
      if (this.props.firstTimeUser) {
        this.props.showOnboarding();
      }
    }
  }

  render() {
    const { firstTimeUser, intl } = this.props;
    return (
      <PageLayout className={this.state.permissionVisible ? '' : classes.hiddenPermission}>
        <section className={classes.permissionContainer}>
          <div className={classes.imageSorter}>
            <img src={buddyIcon} alt={intl.formatMessage(messages.lifesize)} />
          </div>
          {firstTimeUser ?
            <h1 className={classes.firstTimeTitle}>
              <FormattedMessage
                id="components.getPermission.title"
                defaultMessage="Get Started"
              />
            </h1> : <div className={classes.emptyTitle} />}
          <div className={classes.permissionText}>
            <div>
              {firstTimeUser ?
                <FormattedMessage
                  id="components.getPermission.instructions"
                  defaultMessage="First, we need to access your camera and microphone."
                /> :
                <FormattedMessage
                  id="components.getPermission.repeatInstructions"
                  defaultMessage="We've detected that you have not yet allowed Lifesize to access your camera and microphone."
                />
              }
              {firstTimeUser ? null : <div className={classes.emptyDivider} />}
            </div>
            <div>
              <FormattedMessage
                id="components.getPermission.instructionsAllow"
                defaultMessage="Please click {allow} to get started with Lifesize."
                values={{
                  allow: <b>{intl.formatMessage(messages.allow)}</b>
                }}
              />
            </div>
          </div>
        </section>
      </PageLayout>);
  }
}

GetPermission.propTypes = {
  showPermissionPage: PT.bool,
  intl: PT.object,
  firstTimeUser: PT.any,
  showOnboarding: PT.func,
  disableOnboarding: PT.func,
  isAcquiringPrimaryStream: PT.bool
};

export default injectIntl(GetPermission);
